import sm from "./structureMethods-helper";

export default {
// order
  order_tab1_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '입금대기일자', value: 'dt_100'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  order_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 120],
    ['product', '주문 상품', 240],
    ['total_price', '입금액', 100],
    ['status_change', '상태변경', 130]
  ]),

  order_tab2_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '입금대기일자', value: 'dt_100'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' },
        { label: '희망 수령일',  value: 'hope_day'}
      ]
    }
  ],

  order_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['product', '주문 상품', 240],
    ['total_price', '입금액', 100],
    ['status_change', '상태변경', 130]
  ]),

  pay_new_tab1_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: 'no_init',
      end: '',
      key: [
        {label: '결제일자', value: 'dt_101'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: 'no_init',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  pay_new_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['pay_day', '결제일', 120],
    ['hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 120],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),

  pay_new_tab2_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: 'no_init',
      end: '',
      key: [
        {label: '결제일자', value: 'dt_101'},
        {label: '주문일자', value: 'created_time'}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: 'no_init',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  pay_new_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),

  pay_all_tab1_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '주문일자', value: ''},
        {label: '입금대기일자', value: 'dt_100'},
        {label: '결제일자', value: 'dt_101'},
        {label: '상품준비중일자', value: 'dt_200'},
        {label: '배송대기일자', value: 'dt_300'},
        {label: '배송중일자', value: 'dt_301'},
        {label: '배송완료일자', value: 'dt_302'},
        {label: '구매확정일자', value: 'dt_400'},
        {label: '취소요청일자', value: 'dt_500'}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '주문 상태',
      type: 'status_list',
      key: 'status_list'
    },
    {
      title: '결제 수단',
      type: 'radiobutton',
      key: 'pay_type',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: '신용카드', value:0},
        {label: '휴대폰결제', value:1},
        {label: '무통장입금', value:2},
        {label: '실시간 계좌이체', value:3},
        {label: '현장 결제', value:901},
      ]
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  pay_all_tab1_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['pay_day', '결제일', 120],
    ['hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 120],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
  ]),

  pay_all_tab2_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '주문일자', value: ''},
        {label: '입금대기일자', value: 'dt_100'},
        {label: '결제일자', value: 'dt_101'},
        {label: '상품준비중일자', value: 'dt_200'},
        {label: '배송대기일자', value: 'dt_300'},
        {label: '배송중일자', value: 'dt_301'},
        {label: '배송완료일자', value: 'dt_302'},
        {label: '구매확정일자', value: 'dt_400'},
        {label: '취소요청일자', value: 'dt_500'}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '주문 상태',
      type: 'status_list',
      key: 'status_list'
    },
    {
      title: '결제 수단',
      type: 'radiobutton',
      key: 'pay_type',
      value: null,
      /*
        0: 'credit',
            1: 'phone',
            2: 'nobank',
            3: 'trans',
            4: 'vbank',
            5: 'kakaopay',
            6: 'naver',
            7: 'easypay',
            8: 'enclosure',
            900: 'nopay',
            901: 'offline_pay',
         */
      options: [
        { label: '전체', value:null },
        {label: '신용카드', value:0},
        {label: '휴대폰결제', value:1},
        {label: '무통장입금', value:2},
        {label: '실시간 계좌이체', value:3},
        {label: '가상계좌', value:4},
        {label: '카카오페이', value:5},
        {label: '현장 결제', value:901},
      ]
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  pay_all_tab2_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['status_kor', '주문상태', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
  ]),

  // goods
  goods_new_tab1_filter_data: [
    {
      title: '주문일자',
      type: 'period1',
      start: '',
      end: ''
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  goods_new_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['pay_day', '결제일', 120],
    ['hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 120],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),


  goods_new_tab2_filter_data: [
    {
      title: '주문일자',
      type: 'period1',
      start: '',
      end: ''
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  goods_new_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),

  goods_all_tab1_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '상품준비중일자', value: 'dt_200'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  goods_all_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['pay_day', '결제일', 120],
    ['hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 120],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),


  goods_all_tab2_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '상품준비중일자', value: 'dt_200'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  goods_all_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),

  // delivery
  delivery_new_tab1_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '배송대기일자', value: 'dt_300'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '배달담당자 여부',
      type: 'radiobutton',
      key: 'is_delivery_manager',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: '담당자 배정', value:false },
        { label: '담당자 미배정', value:true }
      ]
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' },
        { label: '배달담당자', value: 'delivery_manager_name'}
      ]
    }
  ],

  delivery_new_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['pay_day', '결제일', 120],
    ['hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 120],
    ['delivery_manager', '배달 담당자', 225],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),


  delivery_new_tab2_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '배송대기일자', value: 'dt_300'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '배달담당자 여부',
      type: 'radiobutton',
      key: 'is_delivery_manager',
      value: null,
      options:[
        { label: '전체', value:null },
        { label: '담당자 배정', value:false },
        { label: '담당자 미배정', value:true }
      ]
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' },
        { label: '배달담당자', value: 'delivery_manager_name'}
      ]
    }
  ],

  delivery_new_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['delivery_manager', '배달 담당자', 225],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),

  deliverying_tab1_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '배송중일자', value: 'dt_301'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  deliverying_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['pay_day', '결제일', 120],
    ['hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 120],
    ['delivery_manager', '배달 담당자', 120],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),


  deliverying_tab2_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '배송중일자', value: 'dt_301'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  deliverying_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['delivery_manager', '배달 담당자', 120],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),

  delivery_all_tab1_filter_data: [
    {
      title: '주문일자',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '주문일자', value: ''},
        {label: '배송대기일자', value: 'dt_300'},
        {label: '배송중일자', value: 'dt_301'},
        {label: '배송완료일자', value: 'dt_302'}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  delivery_all_tab1_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['pay_day', '결제일', 120],
    ['hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '주문번호', 120],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100]
  ]),


  delivery_all_tab2_filter_data: [
    {
      title: '주문일자',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '주문일자', value: ''},
        {label: '배송대기일자', value: 'dt_300'},
        {label: '배송중일자', value: 'dt_301'},
        {label: '배송완료일자', value: 'dt_302'}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  delivery_all_tab2_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100]
  ]),

  delivery_success_tab1_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '배송완료일자', value: 'dt_302'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  delivery_success_tab1_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['pay_day', '결제일', 120],
    ['hope_day', '수령희망일', 120],
    ['delivery_success_day', '배달완료일', 120],
    ['order', '주문자', 80],
    ['delivery_manager', '배달 담당자', 120],
    ['id', '주문번호', 120],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),


  delivery_success_tab2_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '배송완료일자', value: 'dt_302'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  delivery_success_tab2_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order__delivery_success_day', '배달완료일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['delivery_manager', '배달 담당자', 120],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),

  order_settle_tab1_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '구매확정일자', value: 'dt_400'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  order_settle_tab1_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['pay_day', '결제일', 120],
    ['hope_day', '수령희망일', 120],
    ['delivery_success_day', '배달완료일', 120],
    ['order', '주문자', 80],
    ['delivery_manager', '배달 담당자', 120],
    ['id', '주문번호', 120],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100]
  ]),


  order_settle_tab2_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '구매확정일자', value: 'dt_400'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  order_settle_tab2_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order__delivery_success_day', '배달완료일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['delivery_manager', '배달 담당자', 120],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
  ]),

  // return
  return_new_filter_data: [
    {
      title: '주문일자',
      type: 'period1',
      start: '',
      end: ''
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  return_new_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),

  returning_filter_data: [
    {
      title: '주문일자',
      type: 'period1',
      start: '',
      end: ''
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  returning_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),

  return_all_filter_data: [
    {
      title: '주문일자',
      type: 'period1',
      start: '',
      end: ''
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  return_all_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),

  refund_new_filter_data: [
    {
      title: '주문일자',
      type: 'period1',
      start: '',
      end: ''
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  refund_new_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),

  refund_all_filter_data: [
    {
      title: '주문일자',
      type: 'period1',
      start: '',
      end: ''
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  refund_all_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '수량', 80],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),

  cancel_new_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '취소요청일자', value: 'dt_500'},
        {label: '주문일자', value: ''}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  cancel_new_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '취소 수량', 100],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_change', '상태변경', 130]
  ]),

  cancel_all_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: '',
      key: [
        {label: '주문일자', value: ''},
        {label: '취소요청일자', value: 'dt_500'},
        {label: '취소완료(입금전 주문취소)', value: 'dt_503'},
        {label: '취소완료(환불 완료)', value: 'dt_504'}
      ]
    },
    {
      title: '수령희망일',
      date_type: 'date',
      type: 'period',
      start: '',
      end: '',
      key: 'hope_day'
    },
    {
      title: '파트너',
      type: 'partner',
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '주문번호', value: 'order_num' },
        { label: '주문자명', value: 'name' },
        { label: '상품번호', value: 'id' },
        { label: '상품명', value: 'product_name' },
        { label: '수령지 주소', value: 'address' }
      ]
    }
  ],

  cancel_all_table_data: sm.tableData([
    ['created_time', '주문일', 120],
    ['order__pay_day', '결제일', 120],
    ['order__hope_day', '수령희망일', 120],
    ['order', '주문자', 80],
    ['id', '상품 주문번호', 140],
    ['partner', '파트너', 120],
    ['product', '주문 상품', 240],
    ['product_price', '상품 금액', 100],
    ['quantity', '취소 수량', 100],
    ['delivery_cost', '배달비', 100],
    ['total_price', '총 결제금액', 120],
    ['pay_type', '결제수단', 100],
    ['status_kor', '상태', 100]
  ]),

  // 주문
  account_new_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '파트너명', value: 'partner_name' }
      ]
    }
  ],

  account_new_table_data: sm.tableData([
    ['partner_name', '파트너명', 120],
    ['created_time', '생성날짜', 120],
    ['expect_date', '정산 예상날짜', 120],
    ['min_price', '최소 금액', 120],
    ['total_price', '주문금액(A)', 120],
    ['comm_price', '수수료(B)', 100],
    ['coupon_price', '할인 부담 금액(C)', 120],
    ['delivery_cost', '배달비 부담 금액(D)', 140],
    ['point', '적립 공제 금액(E)', 140],
    ['acc_price', '정산할 금액', 120],
    ['history', '판매내역', 140],
    ['modify_delete', '완료', 120]
  ]),

  // 주문
  account_all_filter_data: [
    {
      title: '기간검색',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '파트너명', value: 'partner_name' }
      ]
    }
  ],

  account_all_table_data: sm.tableData([
    ['acc_date', '정산날짜', 120],
    ['partner_name', '파트너명', 120],
    ['total_price', '주문금액(A)', 120],
    ['comm_price', '수수료(B)', 100],
    ['coupon_price', '할인 부담 금액(C)', 120],
    ['delivery_cost', '배달비 부담 금액(D)', 140],
    ['point', '적립 공제 금액(E)', 140],
    ['acc_price', '정산할 금액', 120],
    ['history', '판매내역', 140]
  ]),
  order_statistics_day_filter_data: [
    {
      title: '기간',
      type: 'period1',
      start: '',
      end: ''
    },
    {
      title: '주문 경로',
      type: 'radiobutton',
      key: 'device_type',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: 'PC', value:'pc'},
        {label: '모바일', value:'mobile'}
      ]
    },
    {
      title: '파트너',
      type: 'partner',
    }
  ],
  order_statistics_day_table_data: sm.tableData([
    ['date', '일자', 120],
    ['order_count', '주문수', 120],
    ['product_price', '상품 판매가', 120],
    ['discount_price', '상품할인', 120],
    ['delivery_cost', '배송비', 120],
    ['total_price', '결제 합계', 120],
    ['refund_price', '환불 합계', 120],
    ['sales_price', '매출 금액', 120],
  ]),
  order_statistics_week_filter_data: [
    {
      title: '기간',
      type: 'week'
    },
    {
      title: '주문 경로',
      type: 'radiobutton',
      key: 'device_type',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: 'PC', value:'pc'},
        {label: '모바일', value:'mobile'}
      ]
    },
    {
      title: '파트너',
      type: 'partner',
    }
  ],
  order_statistics_week_table_data: sm.tableData([
    ['date', '기간', 120],
    ['order_count', '주문수', 120],
    ['product_price', '상품 판매가', 120],
    ['discount_price', '상품할인', 120],
    ['delivery_cost', '배송비', 120],
    ['total_price', '결제 합계', 120],
    ['refund_price', '환불 합계', 120],
    ['sales_price', '매출 금액', 120],
  ]),
  order_statistics_month_filter_data: [
    {
      title: '기간',
      type: 'month'
    },
    {
      title: '주문 경로',
      type: 'radiobutton',
      key: 'device_type',
      value: null,
      options:[
        { label: '전체', value:null },
        {label: 'PC', value:'pc'},
        {label: '모바일', value:'mobile'}
      ]
    },
    {
      title: '파트너',
      type: 'partner',
    }
  ],
  order_statistics_month_table_data: sm.tableData([
    ['date', '기간', 120],
    ['order_count', '주문수', 120],
    ['product_price', '상품 판매가', 120],
    ['discount_price', '상품할인', 120],
    ['delivery_cost', '배송비', 120],
    ['total_price', '결제 합계', 120],
    ['refund_price', '환불 합계', 120],
    ['sales_price', '매출 금액', 120],
  ]),
  order_statistics_product_filter_data: [
    {
      title: '기간',
      type: 'custom_period'
    },
  ],
  order_statistics_product_table_data: sm.tableData([
    ['priority', '순위', 70],
    ['name', '상품명', 390],
    ['product_price', '상품 금액', 120],
    ['order_count', '결제수량', 90],
    ['refund_count', '환불수량', 90],
    ['sales_count', '판매수량', 90],
    ['sales_price', '판매합계', 120]
  ]),
  order_statistics_product_option_filter_data: [
    {
      title: '기간',
      type: 'custom_period'
    },
  ],
  order_statistics_product_option_table_data: sm.tableData([
    ['priority', '순위', 70],
    ['name', '상품명/옵션', 390],
    ['product_price', '상품 금액', 120],
    ['order_count', '결제수량', 90],
    ['refund_count', '환불수량', 90],
    ['sales_count', '판매수량', 90],
    ['sales_price', '판매합계', 120]
  ])
}
